import { render, staticRenderFns } from "./SimulatorPF.vue?vue&type=template&id=f9bc82a2&"
import script from "./SimulatorPF.vue?vue&type=script&lang=js&"
export * from "./SimulatorPF.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPF.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports